module.exports = __webpack_public_path__ + "static/img/Ymparistoministerio.8a81702.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ymparistoministerio.png
// module id = Bzcp
// module chunks = 4